import classNames from 'clsx';
import React, { useContext, useEffect, useLayoutEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';

import StarsButton from '@swf/components/StarsButton/StarsButton';
import type { ModalContextValue } from '@swf/components/StarsModal/Context';
import { ModalContext } from '@swf/components/StarsModal/Context';
import type { Dispatch } from '@swf/core/store';
import { select } from '@swf/core/store';
import type { PageData, PokerContext } from '@swf/core/types/Poker';
import type { HgClubInfo } from '@swf/generated/types/api/v0/SwHomeGames';

import { TXTCLI_OK } from './Success.messages.json';
import styles from './Success.scss';

interface Props {
  title: React.ReactNode;
  text: React.ReactNode;
  imageClassName: string;
}

interface LocationState extends PageData {
  clubId: number;
  fetchService: PokerContext['fetchService'];
}

const Success = ({ title, text, imageClassName = '' }: Props) => {
  const { modal } = useDispatch<Dispatch>();
  const { setStyle } = useContext<ModalContextValue>(ModalContext);

  const {
    state: { clubs, fetchService }
  } = useLocation<LocationState>();
  const language = useSelector(select.locale.get);

  useLayoutEffect(() => {
    setStyle({ className: styles.successModal });
  });

  useEffect(
    () => () => {
      fetchService(
        'clubInfo',
        {
          gameFilter: {
            gameCategoryMask: 255,
            clubIds: clubs.map(({ clubId }: HgClubInfo) => clubId)
          }
        },
        { language }
      );
    },
    [clubs, fetchService, language]
  );

  return (
    <div className={styles.container}>
      <div className={classNames(styles.imageContainer, imageClassName)} />
      <div className={styles.content}>
        <h3>{title}</h3>
        <p>{text}</p>
        <StarsButton
          onClick={() => modal.close()}
          className={styles.button}
          translation={TXTCLI_OK}
        />
      </div>
    </div>
  );
};

export default Success;
